import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import './component.scss'

const app = Application.start()

app.register(
  'sp-header-client-search-modal',
  class extends Controller {
    static targets = ['modal', 'sliderContainer', 'regionsSlide', 'prefecturesSlide', 'prefecturesList']

    connect () {
      // 初期スクロール位置を保存
      this.scrollPosition = 0
      // 現在の表示状態を管理
      this.currentSlide = 'regions'
    }

    // こだわり条件を指定してモーダルを開く
    openClientSearch () {
      // 都道府県リンクのhrefを更新
      this.updatePrefectureLinks()

      // モーダルを開く
      this.open()
    }

    // モーダルを開く
    open () {
      // スクロール位置を保存
      this.scrollPosition = window.pageYOffset

      // bodyのスクロールを無効化
      document.body.style.overflow = 'hidden'

      // 初期状態に戻す
      this.showRegions()

      // モーダル要素を表示
      const modal = this.modalTarget
      const overlay = modal.querySelector('.js-sp-header-client-search-modal-overlay')
      const content = modal.querySelector('.js-sp-header-client-search-modal-content')

      if (modal && overlay && content) {
        modal.classList.add('sp-header-client-search-modal--active')
        overlay.classList.add('sp-header-client-search-modal__overlay--active')
        content.classList.add('sp-header-client-search-modal__content--active')
      }
    }

    // モーダルを閉じる
    close () {
      const modal = this.modalTarget
      const overlay = modal.querySelector('.js-sp-header-client-search-modal-overlay')
      const content = modal.querySelector('.js-sp-header-client-search-modal-content')

      if (overlay && content) {
        overlay.classList.remove('sp-header-client-search-modal__overlay--active')
        content.classList.remove('sp-header-client-search-modal__content--active')

        // アニメーション終了後にモーダルを非表示
        setTimeout(() => {
          if (modal) {
            modal.classList.remove('sp-header-client-search-modal--active')
          }

          // bodyのスクロールを復元
          document.body.style.overflow = ''
          window.scrollTo(0, this.scrollPosition)
        }, 300)
      }
    }

    // 都道府県表示に遷移
    showPrefectures (event) {
      const regionId = event.currentTarget.dataset.regionId

      // 選択した地域の都道府県のみを表示
      this.displayPrefecturesForRegion(regionId)

      // 横スライドアニメーション
      this.regionsSlideTarget.classList.add('slide-to-prefectures')
      this.prefecturesSlideTarget.classList.add('slide-to-prefectures')

      this.currentSlide = 'prefectures'
    }

    // 地域選択に戻る
    showRegions () {
      // すべての都道府県グループを非表示
      const prefectureGroups = this.prefecturesListTarget.querySelectorAll('.sp-header-client-search-modal__prefecture-group')
      prefectureGroups.forEach(group => {
        group.classList.remove('sp-header-client-search-modal__prefecture-group--active')
      })

      // 横スライドアニメーションを元に戻す
      this.regionsSlideTarget.classList.remove('slide-to-prefectures')
      this.prefecturesSlideTarget.classList.remove('slide-to-prefectures')

      this.currentSlide = 'regions'
    }

    // 指定した地域の都道府県を表示
    displayPrefecturesForRegion (regionId) {
      // すべての都道府県グループを非表示
      const prefectureGroups = this.prefecturesListTarget.querySelectorAll('.sp-header-client-search-modal__prefecture-group')
      prefectureGroups.forEach(group => {
        group.classList.remove('sp-header-client-search-modal__prefecture-group--active')
      })

      // 指定した地域の都道府県グループを表示
      const targetGroup = this.prefecturesListTarget.querySelector(`.sp-header-client-search-modal__prefecture-group[data-region-id="${regionId}"]`)
      if (targetGroup) {
        targetGroup.classList.add('sp-header-client-search-modal__prefecture-group--active')
      }
    }

    // 都道府県リンクのhrefとtracking_labelを更新
    updatePrefectureLinks () {
      const prefectureLinks = this.prefecturesListTarget.querySelectorAll('.sp-header-client-search-modal__prefecture-item')

      prefectureLinks.forEach(link => {
        const prefectureName = link.dataset.prefectureName
        const prefectureId = link.dataset.prefectureId
        if (!prefectureName || !prefectureId) return

        // hrefを更新
        link.href = `/area/${prefectureName}/part/exterior_outer-wall`
      })
    }
  }
)
